import { lazy } from 'react';
import { VIEW_CUSTOMER_APP } from 'shared/../constants/CustomerAccess';
import { onLazyImportError } from 'shared/../helpers/common';

const BankingUpdatePage = lazy(() => import(/* webpackChunkName: "bankingUpdate" */ './BankingUpdatePage').catch(onLazyImportError));

const routes = [
  {
    path: '/banking-update',
    exact: true,
    component: BankingUpdatePage,
    requiredAccess: [VIEW_CUSTOMER_APP],
  },
];

export default routes;
